import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { LOADING_BAR_CONFIG, LoadingBarConfig, LoadingBarModule } from '@ngx-loading-bar/core';
import { LoadingBarRouterModule } from '@ngx-loading-bar/router';
import { UiProgressBarLoaderComponent } from './ui-progress-bar-loader/ui-progress-bar-loader.component';

@NgModule({
  imports: [CommonModule, MatProgressBarModule, LoadingBarModule, LoadingBarRouterModule],
  declarations: [UiProgressBarLoaderComponent],
  exports: [UiProgressBarLoaderComponent],
  providers: [
    {
      provide: LOADING_BAR_CONFIG,
      useValue: {
        latencyThreshold: 80
      } as LoadingBarConfig
    }
  ]
})
export class CoreFeatureProgressBarLoaderModule {}
